import { DatasetDetailView } from "@/components/eval/DatasetDetailView";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/eval/datasets/$id")({
	component: () => {
		const { id } = Route.useParams();
		return <DatasetDetailView datasetId={id} />;
	},
});
